import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>{" "}
          <div className="casino-result-cards-item">
            <img src={getCardImage(cards[0])} alt="" />
          </div>{" "}
          <div className="casino-result-cards-item">
            <img src={getCardImage(cards[1])} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 2 Cards Teenpatti (patti2): A = cards[0,2], B = cards[1,3],
 * trophy before the winner's cards (win 1 → A, 2 → B); rdesc "winner#baccarat#total#colorplus".
 */
export default function Patti2ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const row = (label, value) => (
    <div className="casino-result-desc-item">
      <div>{label}</div> <div>{value}</div>
    </div>
  );

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <PlayerCards name="Player A" cards={[cards[0], cards[2]]} isWinner={win === "1"} />{" "}
          <div className="casino-result-content-diveder" />{" "}
          <PlayerCards name="Player B" cards={[cards[1], cards[3]]} isWinner={win === "2"} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {row("Winner", desc[0])}{" "}
            {row("Mini Baccarat", desc[1])}{" "}
            {row("Total", desc[2])}{" "}
            {row("Color Plus", desc[3])}
          </div>
        )}
      </div>
    </div>
  );
}
